import { useState } from 'react'
import { ReactState } from '../Types/Types'

const SECURITY_ID: string = 'SecurityID'

export const useIsScheduledReport = () => {
    const isScheduledReportInitial = () => {
        const params: URLSearchParams = new URLSearchParams(window.location.search)
        return params.has(SECURITY_ID)
    }

    const [isScheduledReport]: ReactState<boolean> = useState<boolean>(isScheduledReportInitial())

    return isScheduledReport
}
